import Service from "../../Services";

const Program = {
    namespaced : true,
    state : {
        form : null,
        programs : null,
        services : [],
        service_floors : [],
        banner: null,
        service_area : {
            branch_id : '',
            floor_id : '',
            images : '',
            access_type_id : '',
            slug_url : '',
            travel : '',
            restaurant : null,
            group_visit : null,
            name : '',
            description : '',
        },
        worldCalendar: null,
        worldCalendarById: null
    },
    mutations : {
        SET_FORM_BY_EVENT_ID : (state,res)=>{
            state.form = res;
        },
        SET_PROGRAMS : (state,res)=>{
            state.programs = res;
        },
        SET_SERVICES : (state,res)=>{
            state.services = res;
        },
        setBannerByBranch: (state, res) => {
            state.banner = res;
        },
        setServiceArea: (state, res) => {
            if(res){
                state.service_area = res;
            }
        },
        SET_SERVICE_FLOOR : (state,res)=>{
            state.service_floors = res;
        },
        setWorldCalendar: (state, res) => {
            state.worldCalendar = res;
        },
        setWorldCalendarById: (state, res) => {
            state.worldCalendarById = res;
        }
    },
    actions : {
        // eslint-disable-next-line no-unused-vars
        getProgramEventAll({commit}, {tag, lang, page,sort, eventdate}) {
            return Service.ProgramAPI.getEventAll({tag, lang, page,sort, eventdate}).then(res => {
                commit('SET_PROGRAMS', res);
            });
        },
        getProgramByPage({commit}, {tag, page, sort, eventdate}){
            return Service.ProgramAPI.getEventByPage({tag, page, sort, eventdate}).then(res=>{
                commit('SET_PROGRAMS',res);
            });
        },
        getProgramEventById({ commit },{id , lang}){
            return Service.ProgramAPI.getEventById(id,lang).then(res=>{
                commit('SET_FORM_BY_EVENT_ID',res);
            });
        },
        onGetRelatedEventById({ commit }, id){
            return Service.ProgramAPI.getRelatedEventById(id);
        },
        onGetDesignWorldCalendar({commit}, { date, page, lang }) {
            return Service.ProgramAPI.getDesignWorldCalendar({ date, page, lang }).then(res => {
                commit('setWorldCalendar', res);
            });
        },
        onGetDesignWorldCalendarById({commit}, id) {
            return Service.ProgramAPI.getDesignCalendarById(id).then(res => {
                if (res.response_code === 200) {
                    commit('setWorldCalendarById', res.result);
                }
            });
        }
    },
}
export default Program
